// import type { DataLoaderqueryParams } from '@/types/DataLoaderParams';
import {
    conversationAction,
    ConversationQueryType,
    fetchConversationIfNeeded,
    getConversation,
} from '@/redux/modules/conversation';
import { DataLoaderParams } from '@/types/DataLoaderParams';

import { fetchCatalogsIfNeeded } from '@/redux/modules/catalog';
import { fetchConversationFoldersIfNeeded } from '@/redux/modules/conversationFolders';
import { fetchConversationMessages } from '@/redux/modules/conversationMessages';
import { fetchItemCardModelsIfNeeded } from '@/redux/modules/itemCardModel';
import { fetchSellerFollowerCountIfNeeded } from '@/redux/modules/sellerFollowerCount';
import { fetchSellerRatingsByIdIfNeeded } from '@/redux/modules/sellerRatings';
import { fetchSellersDetailsIfNeeded } from '@/redux/modules/sellerDetail';
import { fetchSellersIfNeeded } from '@/redux/modules/seller';
import { fetchTopSellersIfNeeded } from '@/redux/modules/topRatedSellers';
import { parseQueryParams } from '@/utils/queryParams';

export default async ({ location, match, store }: DataLoaderParams) => {
    const queryParams: ConversationQueryType = parseQueryParams(location.search);
    const { params } = match;
    const { dispatch, getState } = store;
    const conversationId = Number(params.conversationId);

    const promises = [dispatch(fetchTopSellersIfNeeded())];

    if (conversationId) {
        promises.push(dispatch(fetchConversationMessages(conversationId)));
        promises.push(dispatch(fetchConversationIfNeeded(conversationId)));
    } else {
        return Promise.resolve();
    }

    await Promise.all(promises);

    const secondaryPromises = [];
    const secondaryState = getState();
    const { catalogId, itemId, read, sellerId } = getConversation(secondaryState, conversationId);

    if (!read) {
        secondaryPromises.push(dispatch(conversationAction([conversationId], 'markRead', queryParams, true)));
    } else {
        secondaryPromises.push(dispatch(fetchConversationFoldersIfNeeded()));
    }

    if (sellerId) {
        secondaryPromises.push(dispatch(fetchSellersIfNeeded([sellerId])));
        secondaryPromises.push(dispatch(fetchSellersDetailsIfNeeded([sellerId])));
        secondaryPromises.push(dispatch(fetchSellerRatingsByIdIfNeeded({ sellerId })));
        secondaryPromises.push(dispatch(fetchSellerFollowerCountIfNeeded([sellerId])));
    }

    if (catalogId) {
        secondaryPromises.push(dispatch(fetchCatalogsIfNeeded([catalogId])));
    }

    if (itemId) {
        secondaryPromises.push(dispatch(fetchItemCardModelsIfNeeded([itemId], 'MESSENGER-PAGE-DATA-LOADER')));
    }
    return Promise.all(secondaryPromises);
};
